'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const SummaryBox = styled(Box)(({theme}) => ({
    borderRadius: '.5rem',
    padding: '.9rem',
    fontSize: '.8rem',
    width: '70%',
    margin: '0 auto 1rem auto',
    display: 'flex',
    background: theme.palette.custom?.boxSummary,
    color: theme.palette.custom?.textSummary,
    '& p': {
        fontSize: 'inherit'
    }
}));

export default SummaryBox;
